import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import { AnimatePresence, motion } from "framer-motion";
import { FiX } from "react-icons/fi";
import { NavItems } from "../../utility/Navigation";
import "./Header.css";
import { FaRegComment } from "react-icons/fa";

const Hadear = () => {
  const [toggle, setToggle] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [scrolled, setScrolled] = useState(false); // Track scroll

  // Page open popup
const [showPagePopup, setShowPagePopup] = useState(true);

  // Scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuToggle = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  const CloseClick = () => {
    setToggle(false);
    setActiveMenu(null);
  };

  const sidebarVariants = {
    hidden: { x: "100%" },
    visible: { x: 0, transition: { type: "tween", duration: 0.3 } },
    exit: { x: "100%", transition: { type: "tween", duration: 0.3 } },
  };

  const [containerClass, setContainerClass] = useState("container");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 2000) {
        setContainerClass(""); // wide screen → fluid
      } else {
        setContainerClass("container"); // normal container
      }
    };

    handleResize(); // run on first render
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="container">
      {/* ==========================================
    PAGE OPEN POPUP
========================================== */}
{showPagePopup && (
  <div className="page-popup-overlay">

    <div className="page-popup">

      {/* Close Button */}
      <button
        type="button"
        className="page-popup-close"
        onClick={() => setShowPagePopup(false)}
        aria-label="Close popup"
      >
        <FiX size={24} />
      </button>

      {/* Image */}
      <div className="page-popup-image">
        <img
          src="/assets/images/public_notice.png"
          alt="Announcement"
        />
      </div>
      {/* Public Notice Content */}


      {/* Three Links */}
      <div className="page-popup-links">

        <a
          href="https://epaper.eenadu.net/Home/Index?date=04/08/2026&eid=3&pid=3535645"
          target="_blank"
          rel="noopener noreferrer"
          className="page-popup-link"
        >
          Public Notice in Eenadu dated 4th Aug, 2026, Hyderabad - Telangana
        </a>

        <a
          href="https://epaper.eenadu.net/Home/Index?date=04/08/2026&eid=2&pid=3535231"
          target="_blank"
          rel="noopener noreferrer"
          className="page-popup-link"
        >
          Public Notice in Eenadu dated 4th Aug, 2026, Andhra Pradesh
        </a>

        <a
          href="http://epaper.deccanchronicle.com/articledetailpage.aspx?id=19934618"
          target="_blank"
          rel="noopener noreferrer"
          className="page-popup-link"
        >
          Public Notice in Deccan Chronicle dated 4th Aug, 2026, AP & Telangana
        </a>

      </div>

    </div>
  </div>
)}
      <div
        className={`main-header ${
          scrolled ? "header-shadow header-shrink" : ""
        }`}
      >
        <header className={`${containerClass} wraper-header`}>
          {/* Top bar */}
          

          {/* Main header */}
          <div style={{ marginTop: -2 }}>
            <div
              className={`wraper-header-main justify-content-between align-items-center`}
            >
              <div className="header-area">
                <Link to="/" className="logo">
                  <img src="/assets/images/logo.png" alt="logo" />
                </Link>
              </div>

              {/* Desktop menu */}
              <div className="desktopMenu d-none d-xl-block mx-auto">
                <nav>
                  <ul>
                    {NavItems.map((item, index) => (
                      <li
                        key={index}
                        className={item.items ? "hasMenu aboutMenu" : ""}
                        onMouseEnter={() => item.items && setActiveMenu(index)}
                      >
                        {item.items ? (
                          <>
                            <a
                              href="javascript:void(0);"
                              style={{ fontSize: "17px" }}
                            >
                              {item.name}
                            </a>
                            {activeMenu === index && (
                              <ul className="custmmenu rightshift">
                                <li className="hasMenu hasmenu">
                                  <div className="header_part resrcewidth">
                                    <ul style={{ padding: "13px" }}>
                                      {item.items.map((subItem, subIndex) => (
                                        <li
                                          key={subIndex}
                                          className="inrliscndmenulst"
                                        >
                                          <Link
                                            className="atagscndmenulst widthgiven"
                                            to={subItem.link}
                                            onClick={CloseClick}
                                          >
                                            {/* icon */}
                                            <div className="icondivnew">
                                              <div className="iconsctn_imge newthemeicon">
                                                {subItem.image ? (
                                                  <img
                                                    src={subItem.image}
                                                    alt={subItem.title}
                                                    style={{
                                                      width: 140,
                                                      height: 25,
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : typeof subItem.icon ===
                                                  "string" ? (
                                                  <span
                                                    style={{ fontSize: "24px" }}
                                                  >
                                                    {subItem.icon}
                                                  </span>
                                                ) : (
                                                  React.cloneElement(
                                                    subItem.icon,
                                                    { size: 24 }
                                                  )
                                                )}
                                              </div>
                                              <div
                                                className="textBox icncreated"
                                                style={{ marginTop: -6 }}
                                              >
                                                <h4
                                                  className="responsivefonts"
                                                  style={{ color: "#000" }}
                                                >
                                                  {subItem.title}
                                                </h4>
                                              </div>
                                            </div>
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            )}
                          </>
                        ) : (
                          <Link
                            className="maineheadgiven"
                            to={item.link}
                            // style={{ fontSize: "17px" }}
                          >
                            {item.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>

              <div
                className="d-none d-xl-block"
                style={{ marginLeft: "3rem", marginRight: "1rem" }}
              >
                <Link to="/bookmeeting" className="btn-one">
                  Book a Meeting{" "}
                  <motion.i
                    className="fa-regular fa-arrow-right-long"
                    animate={{ x: [0, -10, 0] }}
                    transition={{
                      duration: 2,
                      ease: "linear",
                      repeat: Infinity,
                    }}
                  />
                </Link>
              </div>

              {/* Mobile menu trigger */}
              <button
                className="menuOpen d-block d-xl-none pr-30"
                onClick={() => setToggle(!toggle)}
              >
                {toggle ? (
                  <IoMdClose size={24} />
                ) : (
                  <GiHamburgerMenu size={24} />
                )}
              </button>
            </div>

            {/* Mobile menu */}
            <AnimatePresence>
              {toggle && (
                <>
                  <motion.div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
                    style={{ zIndex: 1040 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={CloseClick}
                  />
                  <motion.div
                    className="position-fixed top-0 end-0 h-100 bg-white shadow p-3"
                    style={{ width: "300px", zIndex: 1050 }}
                    variants={sidebarVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  >
                    <div className="d-flex justify-content-end mb-4">
                      <button onClick={CloseClick} className="btn btn-light">
                        <FiX size={24} />
                      </button>
                    </div>
                    <nav>
                      {NavItems.map((item, idx) => (
                        <div key={idx} className="mb-3">
                          {item.items ? (
                            <>
                              <p className="text-uppercase text-muted small fw-bold mb-2">
                                {item.name}
                              </p>
                              <ul className="list-unstyled ms-2">
                                {item.items.map((sub, subIdx) => (
                                  <li key={subIdx} className="mb-2">
                                    <Link
                                      to={sub.link}
                                      className="d-flex align-items-center text-decoration-none text-dark"
                                      onClick={CloseClick}
                                    >
                                      {sub.icon && (
                                        <span className="me-2">{sub.icon}</span>
                                      )}
                                      {sub.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : (
                            <Link
                              to={item.link}
                              className="d-flex align-items-center text-decoration-none text-dark"
                              onClick={CloseClick}
                            >
                              {item.icon && (
                                <span className="me-2">{item.icon}</span>
                              )}
                              {item.name}
                            </Link>
                          )}
                        </div>
                      ))}
                      <div className="mt-3">
                        <Link
                          to="/request-demo"
                          className="btn btn-primary w-100"
                          onClick={CloseClick}
                        >
                          Request Demo
                        </Link>
                      </div>
                    </nav>
                  </motion.div>
                </>
              )}
            </AnimatePresence>
          </div>
        </header>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        {/* Floating Button */}
        <motion.div
          onClick={() => {
            const el = document.getElementById("testimonial");
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            } else {
              window.location.href = "/";
            }
          }}
          style={{
            background: "#ACEA94",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          animate={{
            y: [0, -15, 10],
            boxShadow: [
              "0 4px 8px rgba(0,0,0,0.2)",
              "0 8px 16px rgba(0,0,0,0.3)",
              "0 4px 8px rgba(0,0,0,0.2)",
            ],
          }}
          transition={{
            duration: 3,
            ease: "easeInOut",
            repeat: Infinity,
          }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaRegComment size={24} color="#fff" />
        </motion.div>

        
      </div>
    </div>
  );
};

export default Hadear;
